<div class="ds-dashboard-layout" id="chat-windowTag">
    
    <!-- LEFT PANE: User List (Sidebar) -->
    <div class="ds-dashboard-sidebar" [ngClass]="{'is-mobile-hidden': ChatconvoOpened}">
        
        <!-- Filter Tabs -->
        <div class="filter-tags-bar">
            <select id="filterName" #filterSelect style="display:none" (change)="Checkchatandmessage(true)">
                <option value="all">All</option>
                <option value="unreadmsg">Unread Message</option>
                <option value="onlineusers">Online Users</option>
                <option value="offlineusers">Offline Users</option>
                <option value="Snooze">Snoozed</option>
            </select>
            <div class="filter-radio-group">
                <input type="radio" id="f-all" name="chatFilter" value="all"
                    (change)="filterSelect.value='all'; searchUserlist()">
                <label for="f-all">All</label>

                <input type="radio" id="f-unread" name="chatFilter" value="unreadmsg" checked
                    (change)="filterSelect.value='unreadmsg'; unreadSubFilter='assigned'; searchUserlist()">
                <label for="f-unread">Unread</label>

                <input type="radio" id="f-online" name="chatFilter" value="onlineusers"
                    (change)="filterSelect.value='onlineusers'; searchUserlist()">
                <label for="f-online">Online</label>

                <input type="radio" id="f-offline" name="chatFilter" value="offlineusers"
                    (change)="filterSelect.value='offlineusers'; searchUserlist()">
                <label for="f-offline">Offline</label>

                <input type="radio" id="f-snooze" name="chatFilter" value="Snooze"
                    (change)="filterSelect.value='Snooze'; searchUserlist()">
                <label for="f-snooze">Snoozed</label>
            </div>

            <!-- Unread Sub-Filters: Assigned vs Others -->
            <div class="unread-sub-filters" *ngIf="filterSelect.value === 'unreadmsg'">
                <div class="filter-radio-group sub-group">
                    <input type="radio" id="f-assigned" name="unreadSubFilter" value="assigned" 
                        [checked]="unreadSubFilter === 'assigned'"
                        (change)="unreadSubFilter='assigned'; searchUserlist()">
                    <label for="f-assigned">
                        <i class="fa fa-user-circle-o" style="margin-right: 4px;"></i> Assigned
                    </label>

                    <input type="radio" id="f-others" name="unreadSubFilter" value="others"
                        [checked]="unreadSubFilter === 'others'"
                        (change)="unreadSubFilter='others'; searchUserlist()">
                    <label for="f-others">
                        <i class="fa fa-users" style="margin-right: 4px;"></i> Others
                    </label>
                </div>
            </div>
        </div>

        <!-- Unified Search Bar -->
        <div class="search-bar-unified-container">
            <div class="search-bar-inner">
                <i class="fa fa-search"></i>
                <input type="text" placeholder="Search customer ID or name..." id="serachChatUser" (keyup)="searchUser()" autocomplete="off" />
            </div>
        </div>

        <!-- Person List -->
        <cdk-virtual-scroll-viewport itemSize="72" class="chat-list-viewport" id="main-contact-viewport" *ngIf="!isSnoozeselected">
            <div class="person-card" [ngClass]="{'is-active': selectedFriendId == friend.id}" id="contact-id-{{friend.id}}" *cdkVirtualFor="let friend of friendsList2" 
                (click)="selectFriendToChat(friend.id)">
                
                <div class="avatar-area">
                    <div class="avatar-circle">
                        {{getInitials(friend.firstname,friend.lastname)}}
                        <span class="status-dot" [ngClass]="friend.online == 'Y' ? 'online' : 'offline'"></span>
                    </div>
                </div>

                <div class="card-details">
                    <div class="card-title">{{friend.firstname}}</div>
                    <div class="card-subtitle">CID: {{friend.userid}} <!-- <span *ngIf="friend.assigned_admin_id == UserId" class="badge-assigned"><i class="fa fa-shield"></i> Mine</span> --></div>
                </div>

                <div class="card-actions-area">
                   
                    <!-- Claim / Unassign Quick Actions -->
                    <!-- <div class="card-quick-actions" (click)="$event.stopPropagation()">
                        <button *ngIf="!friend.assigned_admin_id" (click)="assignCustomer(friend.id)" class="btn-claim-card" title="Claim Customer">
                            <i class="fa fa-hand-o-right"></i>
                        </button>
                        <button *ngIf="friend.assigned_admin_id == UserId" (click)="unassignCustomer(friend.id)" class="btn-unassign-card" title="Unassign">
                            <i class="fa fa-times-circle"></i>
                        </button>
                    </div> -->

                    <!-- Snooze DROPDOWN (Synced with Header) -->
                    
                     <div class="dropdown list-snooze-dropdown" *ngIf="unreadSubFilter === 'others'"  >
                          <button class="btn btn-snooze-card dropdown-toggle" type="button" (click)="assignMe(friend)"  >
                           Assign Me
                     </button>
                     </div>
                    <div class="dropdown list-snooze-dropdown" (click)="$event.stopPropagation()" (mouseleave)="closeSnoozeDropdown($event)">
                        <button class="btn btn-snooze-card dropdown-toggle" type="button" data-bs-toggle="dropdown" data-bs-boundary="viewport">
                            Snooze
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <div class="dropdown-header">Snooze Until...</div>
                            <li *ngIf="showSnoozeLastDayOption"><a class="dropdown-item" (click)="snoozeChat('latertoday',friend.id)"><i class="fa fa-moon-o"></i> Later Today {{ GetSnoozedateoption('later') }} PM</a></li>
                            <li><a class="dropdown-item" (click)="snoozeChat('tomorrow',friend.id)"><i class="fa fa-sun-o"></i> Tomorrow {{ GetSnoozedateoption('Tomorrow') }} AM</a></li>
                            <li><a class="dropdown-item" (click)="snoozeChat('pickdatetime',friend.id)"><i class="fa fa-calendar"></i> Pick Date & Time</a></li>
                        </ul>
                    </div>
                     <span class="unread-badge" *ngIf="friend.mcnt != 0 && friend.mcnt">
                        {{friend.mcnt}}
                    </span>
                </div>
            </div>
        </cdk-virtual-scroll-viewport>

        <!-- Snooze List -->
        <div id="snooze-list-container" class="chat-list-viewport" *ngIf="isSnoozeselected">
            <div class="person-card is-snoozed" [ngClass]="{'is-active': selectedFriendId == friend.sn_user_id}" id="contact-id-{{friend.sn_user_id}}" *ngFor="let friend of snoozelist" 
                (click)="selectFriendToChatfromSnooze(friend.sn_user_id)">
                
                <div class="avatar-area">
                    <div class="avatar-circle snoozed" style="background: linear-gradient(135deg, #6366F1, #4F46E5);">
                        <i class="fa fa-clock-o"></i>
                    </div>
                </div>

                <div class="card-details">
                    <div class="card-title">{{friend.firstname}}</div>
                    <div class="text-snooze-detail" style="font-size: 11px; color: #6366F1; font-weight: 700;">
                        Snoozed until {{DateFormat(friend.snoozed_until)}}
                    </div>
                </div>

                <div class="card-actions-area">
                    <button class="btn-icon-danger" (click)="$event.stopPropagation(); confirmRemoveSnoozeyes(friend)" 
                        style="width: 32px; height: 32px; border-radius: 10px; border: none; background: #FEE2E2; color: #EF4444;">
                        <i class="fa fa-trash"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- RIGHT PANE: Chat Detail Area -->
    <div class="ds-chat-main-area" [ngClass]="{'is-mobile-visible': ChatconvoOpened}" *ngIf="ChatconvoOpened || !isMobile">
        
        <!-- Empty State -->
        <div class="chat-empty-state" *ngIf="!ChatconvoOpened" style="padding: 40px; text-align: center; margin-top: 100px;">
            <i class="fa fa-comments-o" style="font-size: 80px; color: #1877F2; margin-bottom: 24px; opacity: 0.1;"></i>
            <h3 style="font-weight: 800; color: #1E293B;">Select a Chat</h3>
            <p style="color: #64748B;">Pick a customer to start messaging.</p>
        </div>

        <!-- Active Chat -->
        <div class="message-box" id="message-box" *ngIf="ChatconvoOpened">
            <div class="chat-header">
                <div class="header-left">
                    <button class="btn-back mobile-only" (click)="closechat()" style="background: none; border: none; font-size: 20px; padding-right: 15px;">
                        <i class="fa fa-arrow-left"></i>
                    </button>
                    <div class="avatar-circle header-avatar shadow-sm">
                        {{getInitials(selectedFriend?.firstname, selectedFriend?.lastname)}}
                    </div>
                    <div class="chat-about">
                        <h6 (click)="userparent(selectedUserID)" [attr.title]="selectedFriend?.firstname + ' ' + selectedFriend?.lastname">
                            {{selectedFriend?.firstname}} {{selectedFriend?.lastname}}
                        </h6>
                        <div class="header-metadata-row" (click)="userparent(selectedUserID)">
                            <div class="header-id-badge">
                                 CID: <span style="color: #1877F2;">{{selectedFriend?.userid}}</span>
                            </div>
                            
                            <div class="metadata-separator">•</div>

                            <!-- Assign / Claim badges -->
                            <!-- <div class="header-assignment-area" (click)="$event.stopPropagation()">
                                <button *ngIf="selectedFriend && !selectedFriend.assigned_admin_id" (click)="assignCustomer(selectedFriend.id)" class="btn-claim-header">
                                    <i class="fa fa-hand-o-right"></i> <span>Claim Customer</span>
                                </button>
                                <span *ngIf="selectedFriend && selectedFriend.assigned_admin_id == UserId" class="badge-assigned-header" (click)="unassignCustomer(selectedFriend.id)">
                                    <i class="fa fa-check-circle"></i> Assigned to You <i class="fa fa-times"></i>
                                </span>
                            </div> -->
                            
                            <div class="header-snooze-info" *ngIf="snoozedataobj.snoozed_until" (click)="$event.stopPropagation()">
                                <div class="metadata-separator">•</div>
                                <span class="badge-snooze-header">
                                    <i class="fa fa-clock-o"></i> Snoozed until {{DateFormat(snoozedataobj.snoozed_until)}}
                                </span>
                                <button class="btn-remove-snooze-header" (click)="confirmRemoveSnoozeyes({sn_user_id: selectedFriendId}); $event.stopPropagation()">
                                    <i class="fa fa-trash-o"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div class="header-right" style="display: flex; align-items: center; gap: 12px; flex-shrink: 0;">
                    <!-- Chat Search Toggle -->
                    <button class="btn-chat-search-toggle" (click)="toggleChatSearch()" [class.active]="isChatSearchVisible" title="Search in chat">
                        <i class="fa" [ngClass]="isChatSearchVisible ? 'fa-times' : 'fa-search'"></i>
                    </button>

                    <div class="dropdown" *ngIf="enablesnooze && !snoozedataobj.snoozed_until" >
                        <button class="btn btn-sm" style="background: #EBF5FF; color: #1877F2; border: none; font-weight: 800; border-radius: 10px; padding: 8px 16px;" type="button" data-bs-toggle="dropdown" data-bs-boundary="viewport">
                            Snooze <i class="fa fa-angle-down ml-1"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                            <div class="dropdown-header">Snooze Until...</div>
                            <li *ngIf="showSnoozeLastDayOption"><a class="dropdown-item" (click)="snoozeChat('latertoday',selectedFriendId)"><i class="fa fa-moon-o"></i> Later Today {{ GetSnoozedateoption('later') }} PM</a></li>
                            <li><a class="dropdown-item" (click)="snoozeChat('tomorrow',selectedFriendId)"><i class="fa fa-sun-o"></i> Tomorrow {{ GetSnoozedateoption('Tomorrow') }} AM</a></li>
                            <li><a class="dropdown-item" (click)="snoozeChat('pickdatetime',selectedFriendId)"><i class="fa fa-calendar"></i> Pick Date & Time</a></li>
                        </ul>
                    </div>
                    <button class="btn btn-sm btn-danger" *ngIf="convert_id" (click)="endChatConfirm()" style="border-radius: 10px; font-weight: 800; padding: 8px 16px;">
                        End
                    </button>
                </div>
            </div>

            <!-- Expandable Chat Search Bar -->
            <div class="chat-search-container" [class.is-visible]="isChatSearchVisible">
                <div class="chat-search-inner">
                    <i class="fa fa-search"></i>
                    <input type="text" [(ngModel)]="chatSearchQuery" placeholder="Search in this conversation..." autocomplete="off" />
                    <button class="btn-clear-search" *ngIf="chatSearchQuery" (click)="clearChatSearch()">
                        <i class="fa fa-times-circle"></i>
                    </button>
                </div>
            </div>

            <div class="msg-space" id="users-conversation" (scroll)="onScroll($event)">
                <div class="chat-bubbles-container">
                    <div *ngFor="let item of filteredMessages; let i = index" style="width: 100%;">
                        <div class="msgdate"><span>{{todayString(item.date)}}</span></div>
                        
                        <div *ngFor="let messagePacket of item.data" [id]="messagePacket.id" 
                            class="message-packet" [ngClass]="alignMessage(messagePacket.type) ? 'is-other' : 'is-me'">
                            
                            <!-- Full Sender Name Label (Replacing Initials Circle) -->
                            <div class="sender-name-label" [innerHTML]="messagePacket.firstname | highlight: chatSearchQuery"></div>

                            <div class="bubble-common" [ngClass]="alignMessage(messagePacket.type) ? 'other-message' : 'my-message'">
                                <span [innerHTML]="messagePacket.message | highlight: chatSearchQuery"></span>
                                <div class="msg-inner-meta">
                                    <span class="msg-time">{{messagePacket.mtime}}</span>
                                    <div class="bubble-ticks" *ngIf="!alignMessage(messagePacket.type)" style="display: flex; align-items: center; margin-left: 2px;">
                                        <svg class="tick-icon sent" *ngIf="messagePacket.status == 1 && messagePacket.endsess != 2" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                        <svg class="tick-icon read" *ngIf="messagePacket.status == 0 && messagePacket.endsess != 2" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="18 6 7 17 2 12"></polyline>
                                            <path d="M22 6L12 16"></path>
                                        </svg>
                                        <svg class="tick-icon ended" *ngIf="messagePacket.endsess == 2" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="#FCA5A5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                            <polyline points="20 6 9 17 4 12"></polyline>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ds-status-banner-container" *ngIf="endsess == 0">
                        <div class="ds-status-banner">
                            <i class="fa fa-info-circle"></i>
                            This chat session has ended.
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Floating Scroll-to-Bottom Button -->
            <button class="scroll-bottom-btn" [ngClass]="{'is-visible': showScrollToBottom}" (click)="scrollToBottomClicked()">
                <i class="fa fa-arrow-down"></i>
            </button>

            <div class="chat-message">
                <div class="premium-composer-wrapper">
                    <textarea class="composer-input" placeholder="Type a message..." id="message" name="message" 
                        [value]="message" (input)="message=$any($event.target).value" (keyup.enter)="sendMessageClick()" autocomplete="off"></textarea>
                    <button class="premium-send-btn" [class.is-sending-mode]="isSending" (click)="sendMessageClick()" [disabled]="!message || message.trim() == '' || isSending">
                        
                        <span *ngIf="isSending">Sending...</span>
                        <i *ngIf="!isSending" class="fa fa-paper-plane"></i>
                        <i *ngIf="isSending" class="fa fa-spinner fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- MODALS REFINED -->
<!-- Switch Conversation Popup -->
<div class="modal fade zoomIn show confirmmodelfriendid" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Active Session Exists</h5>
                <button type="button" class="btn-close" (click)="hideSwitchModal()"></button>
            </div>
            <div class="modal-body">
                <div class="text-center mb-4">
                    <p style="font-weight: 600; line-height: 1.6;">You currently have an active session. Would you like to end this session?</p>
                </div>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="hideSwitchModal()">Cancel</button>
                <button class="btn btn-danger" style="border-radius: 14px; padding: 12px 28px; font-weight: 700;" (click)="endChatfriend()">Yes, End Session</button>
            </div>
        </div>
    </div>
</div>

<!-- End Chat Popup -->
<div class="modal fade zoomIn show confirmmodel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Finalize Session?</h5>
                <button type="button" class="btn-close" (click)="confirmno()"></button>
            </div>
            <div class="modal-body text-center">
                <p  style="font-weight: 600;">Are you sure you want to end this chat?</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="confirmno()">Cancel</button>
                <button class="btn btn-danger" style="border-radius: 14px; padding: 12px 28px; font-weight: 700;" (click)="endChat()">Yes, End Session</button>
            </div>
        </div>
    </div>
</div>

<!-- Claim Customer Modal -->
<!-- <div class="modal fade zoomIn show claimModel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Claim Customer?</h5>
                <button type="button" class="btn-close" (click)="closeClaimModal()"></button>
            </div>
            <div class="modal-body text-center">
                <p style="font-weight: 600;">Are you sure you want to assign this customer to yourself?</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="closeClaimModal()">Cancel</button>
                <button class="modal-btn-confirm" (click)="confirmAssignCustomer()">Yes, Claim</button>
            </div>
        </div>
    </div>
</div> -->

<!-- Unassign Customer Modal -->
<!-- <div class="modal fade zoomIn show unassignModel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Unassign Customer?</h5>
                <button type="button" class="btn-close" (click)="closeUnassignModal()"></button>
            </div>
            <div class="modal-body text-center">
                <p style="font-weight: 600;">Are you sure you want to remove yourself as the assigned teller for this customer?</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="closeUnassignModal()">Cancel</button>
                <button class="btn btn-danger" style="border-radius: 14px; padding: 12px 28px; font-weight: 700;" (click)="confirmUnassignCustomer()">Yes, Unassign</button>
            </div>
        </div>
    </div>
</div> -->

<!-- Date Picker Modal Polished -->
<div class="modal fade zoomIn show DatepickerModel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Snooze Conversation</h5>
                <button type="button" class="btn-close" (click)="confirmsnoozeno()"></button>
            </div>
            <div class="modal-body">
                <label class="form-label" style="font-weight: 800; color: #94A3B8; font-size: 11px; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 12px; display: block;">Snooze Until</label>
                <div class="snooze-input-container" [ngClass]="{'border-danger': !snoozepickeddatetime && snoozeTouched}" (click)="snoozeTouched = true">
                    <i class="fa fa-calendar"></i>
                    <input type="text" id="selctedsnoozeata" placeholder="Select Date & Time" readonly [(ngModel)]="snoozepickeddatetime" name="snoozepickeddatetime">
                </div>
                <div *ngIf="!snoozepickeddatetime && snoozeTouched" class="text-danger mt-2" style="font-size: 11px; font-weight: 700;">
                    <i class="fa fa-exclamation-circle mr-1"></i> Please select a valid date and time.
                </div>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="confirmsnoozeno()">Cancel</button>
                <button class="modal-btn-confirm" (click)="submitpck()" [disabled]="!snoozepickeddatetime">Confirm Snooze</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade zoomIn show confirmsnooze" tabindex="-1" style="display: none;"><div class="modal-dialog modal-dialog-centered"><div class="modal-content"><div class="modal-body text-center"><h4 class="fs-semibold mb-5">Add snooze?</h4><div class="hstack gap-2 justify-content-center"><button class="btn btn-dark" (click)="confirmsnoozeno()">No</button><button class="btn btn-primary" (click)="confirmsnoozeyes()">Yes</button></div></div></div></div></div>
<div class="modal fade zoomIn show confirmRemoveSnooze" tabindex="-1" style="display: none;"><div class="modal-dialog modal-dialog-centered"><div class="modal-content"><div class="modal-body text-center"><h5 class="mb-4" style="font-weight: 800;">Remove this snooze?</h5><div class="hstack gap-3 justify-content-center"><button class="btn btn-light" style="border-radius: 12px; font-weight: 700;" (click)="confirmRemoveSnoozeno()">Cancel</button><button class="btn btn-danger" style="border-radius: 12px; font-weight: 700;" (click)="confirmRemoveSnoozeyes({sn_user_id: selectedFriendId})">Remove</button></div></div></div></div></div>
<!-- Idle / Timeout Modal -->
<div class="modal fade zoomIn show" id="idlemodel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Inactivity Log Out</h5>
            </div>
            <div class="modal-body text-center">
                <i class="fa fa-clock-o mb-4" style="font-size: 50px; color: #6366F1; opacity: 0.5;"></i>
                <h4 class="fs-semibold mb-3">{{idleState}}</h4>
                <p class="text-muted" style="font-size: 13px; line-height: 1.6;">For your security, sessions automatically end after a period of inactivity unless you choose to stay logged in.</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="idleLogout()">Log Out</button>
                <button class="modal-btn-confirm" (click)="stay()">Stay Logged In</button>
            </div>
        </div>
    </div>
</div>

<!-- Confirm Presence / User Status Check Modal -->
<div class="modal fade zoomIn show" id="confirmIdel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Still There?</h5>
            </div>
            <div class="modal-body text-center">
                <p style="font-weight: 600; font-size: 16px;">Are you sure you want to end this chat session?</p>
                <p class="text-muted" style="font-size: 13px;">Please confirm if you are still active or if you'd like to close this session.</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-cancel mr-2" (click)="userendChat()">Yes, End Session</button>
                <button class="modal-btn-confirm" (click)="userStay()">No, I'm Here</button>
            </div>
        </div>
    </div>
</div>


<div class="modal fade zoomIn show " id="confirmAssignMe" tabindex="-1" style="display: none;background: rgba(0,0,0,0.6);">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      
      <div class="modal-body text-center">
        
        <h5 class="mb-4" style="font-weight: 800;">
         This chat is currently assigned to another agent. Would you like to reassign it to yourself?
        </h5>

        <div class="hstack gap-3 justify-content-center">
          
          <button 
            class="btn btn-light" 
            style="border-radius: 12px; font-weight: 700;" 
            (click)="confirmAssignMeNo()">
            Cancel
          </button>

          <button 
            class="btn btn-primary" 
            style="border-radius: 12px; font-weight: 700;" 
            (click)="confirmAssignMeYes()">
            Assign Me
          </button>

        </div>

      </div>

    </div>
  </div>
</div>


<!-- Session Conflict / Already Finalized Modal -->
<div class="modal fade zoomIn show alreadymodel" tabindex="-1" style="display: none; background: rgba(0,0,0,0.6);">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Unable to Send Message</h5>
                <button type="button" class="btn-close" (click)="endalready()"></button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-4">
                    <i class="fa fa-info-circle" style="font-size: 40px; color: #1877F2; opacity: 0.3;"></i>
                </div>
                <p style="font-weight: 600; line-height: 1.6;">Messages cannot be sent to this customer at the moment. The customer is in the middle of a conversation with another teller.</p>
                <p class="text-muted" style="font-size: 13px; margin-top: 10px;">Please try again later.</p>
            </div>
            <div class="modal-footer">
                <button class="modal-btn-confirm" (click)="endalready()">Ok, Got it</button>
            </div>
        </div>
    </div>
</div>